import React from "react";
import DstNavbar from "../../../components/DstNavbar/DstNavbar";
import PreFooterOmnes from "../../../components/PreFooterOmnes/PreFooterOmnes";
import DstFooter from "../../../components/DstFooter/DstFooter";
import { Container } from "react-bootstrap";
import { ContactSection } from "../Formation.component";

const IngenieurQualiteNucleaire = () => {
  return (
    <React.Fragment>
      <DstNavbar />
      <Container>
        <h1 className="text-center my-4">WIP</h1>
        <p className="h4">
          Nous travaillons actuellement sur la mise en ligne de notre page web.
          En attendant, vous pouvez recevoir notre programme en remplissant le
          formulaire ci-dessous. Merci de votre patience et de votre
          compréhension.
        </p>
      </Container>
      <Container className="mt-3 mt-md-5">
        <ContactSection
          portalId="19831339"
          formId="4defc52b-aee3-4f81-b136-84c439936959"
        />
      </Container>
      <PreFooterOmnes />
      <DstFooter />
    </React.Fragment>
  );
};

export default IngenieurQualiteNucleaire;
